import React, { useState } from 'react'
import { Alert, Form, Icon, InputGroup, Radio, RadioGroup, Schema, SelectPicker } from 'rsuite';
import { fetchSinToken } from '../../../helpers/fetch';
import { MaskedInputPhone } from '../../../helpers/formControlInputs';
import { TextField } from '../../../helpers/FormControlRSuit';

export const Step2 = ({handleNext, cliente, setCliente}) => {
    const [formValue, setFormValue] = useState({
        nombre: '',
        ape_paterno: '',
        grupo: '',
        turno: '',
        sexo: '',
        correo: '',
        password: '',
        password2: '',
        dia: '0',
        mes: '0',
        anio: '0',
        celular: '',
        casa: '',
        emergencia: '',
        tutor: '',
        enfermedades: '',
        codigo_preregistro_id: cliente.codigo_preregistro_id,
    });
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [form, setform] = useState({});
    const [enfermedad, setEnfermedad] = useState(false);

    const handleSubmit = async () => {
        setDisabledBtn(true);
        if (form.check()) {
            const resp = await fetchSinToken('preregistro/create', formValue, 'POST', 'json');
            const body = await resp.json();
            if(!body.ok) {
                Alert.error('No se pudo crear tu contrato, intetna refrescar la pagina', 5000)
            }else {
                console.log(body.data);
                setCliente(e => ({
                    ...e, 
                    contrato: body.data.contrato,
                    cliente_id: body.data.id
                }));
                handleNext();
            }
        }
        setDisabledBtn(false)
    }

    return (
        <div className="h-100">
            <Form
                fluid
                ref={ref => (setform(ref))}
                onChange={formValue => {
                    setFormValue(formValue);
                }}
                formValue={formValue}
                model={model}
            >
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="text-left">
                            <p className="mb-2 mx-auto">Para comenzar necesitamos algunos datos personales, esto es para generar tu contrato personalizado y saber un poco más de ti.</p>
                            <p className="mb-2 mx-auto">Todos tus datos estaran protegidos, puedes revisar nuestro <a href="https://viveskyfest.com">Aviso de Privacidad</a>.</p>
                        </div>
                    </div>
                    {/* end col */}
                </div>
                <div className="row mb-4">
                    <div className="col-12">
                        <div className="text-left">
                            <h5 className="mb-2 mx-auto">Datos del adulto titular de la habitacion:</h5>
                        </div>
                    </div>
                    {/* end col */}
                </div>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <TextField 
                            label="Nombre"
                            name="nombre"
                            placeholder="Nombre"
                        />
                    </div> {/* end col */}
                    <div className="col-md-6">
                        <TextField 
                            label="Apellidos"
                            name="ape_paterno"
                            placeholder="Apellidos"
                        />
                    </div> {/* end col */}
                    <div className="col-md-6">
                        <div className="form-group mb-0">
                            <label className="" htmlFor="esculea-input">Escuela</label>
                            <input type="text" id="esculea-input" readOnly={true} className="form-control-plaintext text-info form-control-lg" value={cliente.escuela} required={true} />
                        </div>
                    </div>
                    
                </div> {/* end row */}

                <div className="row">
                    <div className="col">
                        <TextField 
                            name="sexo" 
                            label="Sexo" 
                            accepter={RadioGroup}
                            inline
                        >
                            <Radio inline value="H"><Icon icon='male' /> Hombre</Radio>
                            <Radio inline value="M"><Icon icon='female' /> Mujer</Radio>
                        </TextField>
                    </div>
                </div>

                <fieldset>
                    <div className="row">
                        <div className="col-md-7">
                            <TextField 
                                label="Correo"
                                name="correo"
                                id="correoInput"
                                placeholder="Correo electronico"
                                onChange={(event) => {
                                    setFormValue(e => ({...e, correo: event.replace(/ /g, "")}));
                                }}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <TextField 
                                label="Contraseña"
                                name="password"
                                type="password"
                                placeholder="Contraseña"
                            />
                        </div>
                        <div className="col-md-6">
                            <TextField 
                                label="Repetir contraseña"
                                name="password2"
                                type="password"
                                placeholder="Contraseña"
                            />
                        </div>
                        <small className="ml-2" style={{fontSize: '0.7rem'}}><span className="d-none1d-sm-inline">Crea tu contraseña para entrar a tu perfil </span>(minimo 8 caracteres).</small>
                    </div>
                    {/* <div className="row mt-2">
                        <div className="col-md-6">
                            <div className="form-group mb-0">
                                <label>Fecha de nacimiento</label>
                                <InputGroup 
                                    name="fecha"
                                >
                                    <TextField
                                        placeholder="Día"
                                        name="dia"
                                        inline={true}
                                        type="number"
                                    />
                                        <InputGroup.Addon>/</InputGroup.Addon>
                                    <TextField 
                                        placeholder="Més"
                                        name="mes"
                                        inline={true}
                                        type="number"
                                    />
                                        <InputGroup.Addon>/</InputGroup.Addon>
                                    <TextField 
                                        placeholder="Año"
                                        style={{minWidth: '5em'}}
                                        name="anio"
                                        inline={true}
                                        type="number"
                                    />
                                </InputGroup>
                            </div>
                        </div>
                    </div> */}
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <TextField 
                                accepter={MaskedInputPhone}
                                label="Celular"
                                name="celular"
                            />
                        </div>
                        <div className="col-md-6">
                            <TextField 
                                accepter={MaskedInputPhone}
                                label="Telefono de emergencia"
                                name="emergencia"
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        
                        <div className="col-md-8">
                        <TextField 
                            label="Nombre del graduado"
                            name="tutor"
                        />
                        </div>
                            <div className="col-md-3 col-6">
                            <TextField 
                                label="Grupo"
                                name="grupo"
                                placeholder="Grupo"
                            />
                            </div>
                            <div className="col-md-3 col-6">
                            <TextField 
                                name="turno" 
                                label="Turno" 
                                accepter={SelectPicker} 
                                block
                                searchable={false}
                                data={[{value: 'M', label: 'Matutino'}, {value: 'V', label: 'Vespertino'}]} 
                            />
                            </div>
                    </div>
                    <div className="row mt-2 mb-5">
                        <div className="col-md-12">
                            <TextField 
                                inline
                                name="radioEnfermedad" 
                                label="¿Padece alguna enfermedad o alergias?" 
                                accepter={RadioGroup}
                                onChange={(value) => {
                                    setEnfermedad(value);
                                }}
                            >
                                <Radio inline value={true}>Si</Radio>
                                <Radio inline value={false}>No</Radio>
                            </TextField>
                            {
                                enfermedad &&
                                <TextField 
                                    label="Platícanos:"
                                    name="enfermedades"
                                    componentClass="textarea"
                                    style={{minWidth: '100%'}}
                                    rows={5}
                                />
                            }
                        </div>
                    </div>
                </fieldset>
                <button 
                    className="btn btn-primary btn-lg btn-block"
                    disabled={disabledBtn}
                    onClick={() => handleSubmit(form)} 
                    type="button"
                >
                    { disabledBtn  
                        ? <><i className="spinner-border spinner-border-sm" role="status"></i> Cargando...</>
                        : 'Continuar'
                    }
                </button>
            </Form>
        </div>
    )
}

const { StringType, NumberType, BooleanType} = Schema.Types;

let model = Schema.Model({
    nombre: StringType()
        .isRequired('Es requerido'),
    ape_paterno: StringType()
        .isRequired('Es requerido'),
    grupo: StringType()
        .isRequired('Es requerido'),
    turno: StringType()
        .isRequired('Es requerido'),
    sexo: StringType()
        .isRequired('Es requerido'),
    correo: StringType()
        .isRequired('El Correo es requerido.')
        .isEmail('Tiene que ser un correo'),
    password: StringType()
        .isRequired('La contraseña es requerida')
        .minLength(8, 'Minimo 8 caracteres'),
    password2: StringType()
        .isRequired('La contraseña es requerida')
        .addRule((value, data) => {
            if (value !== data.password) {
            return false;
            }
            return true;
        }, 'La contraseña no coincide'),
    // anio: NumberType()
    //     .isRequired('Es requerido')
    //     .pattern(/^[1-2][9,0][0-9]{2}$/, 'El año no es valido'),
    // mes: NumberType()
    //     .isRequired('Es requerido')
    //     .range(1,12, 'El més no es valido'),
    // dia: NumberType()
    //     .isRequired('Es requerido')
    //     .range(1,31, 'El día no es valido'),
    celular: StringType()
        .isRequired('Es requerido')
        .minLength(14, 'El numero de telefono tiene que ser a 10 digitos.'),
    // casa: StringType()
    //     .isRequired('Es requerido')
    //     .minLength(14, 'El numero de telefono tiene que ser a 10 digitos.'),
    emergencia: StringType()
        .isRequired('Es requerido')
        .minLength(14, 'El numero de telefono tiene que ser a 10 digitos.'),
    tutor: StringType()
        .isRequired('Es requerido'),
    radioEnfermedad: BooleanType()
        .isRequired('Es requerido'),
});
